import {
  OPEN_CHAT,
  CLOSE_CHAT,
  CREATE_CHAT,
  COLLAPSE_CHAT,
  COLLAPSE_ALL_CHATS,
  CHANGE_CHAT,
  UPDATE_NEW_CHAT,
  UPDATE_CHAT,
  RECALCULATE_MAX_CHATS,
} from "../constants/actionTypes";

const initialState = {
  chats: [],
  hidden: [],
  maxChats: 2,
};

function unshiftChatAndAddExcessOnHidden(chats, hidden, newChat) {
  let newChats = removeReactivity(chats);
  let poppedChat = newChats.pop();

  newChats.unshift(newChat);

  let newHidden = removeReactivity(hidden);

  poppedChat && newHidden.push(poppedChat);

  return {
    chatsAfter: newChats,
    hiddenAfter: newHidden,
  };
}

function removeReactivity(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function findElementInArrayById(elementsArray, element) {
  return (
    element &&
    elementsArray.length > 0 &&
    elementsArray.find((elem) => elem.id === element.id)
  );
}

function chats(state = initialState, action) {
  switch (action.type) {
    case OPEN_CHAT:
      let openChatChats = removeReactivity(state.chats);
      let openChatHidden = removeReactivity(state.hidden);
      let foundChat = findElementInArrayById(openChatChats, action.chat);

      if (foundChat) {
        const openChatChatIndex = openChatChats.findIndex(
          (elem) => elem.id === action.chat.id
        );
        openChatChats[openChatChatIndex].collapsed = false;

        return {
          ...state,
          chats: openChatChats,
        };
      }

      let foundHiddenChat = findElementInArrayById(openChatHidden, action.chat);
      if (foundHiddenChat) {
        openChatHidden = openChatHidden.filter(
          (elem) => elem.id !== action.chat.id
        );
        foundHiddenChat.collapsed = false;
        openChatChats.unshift(foundHiddenChat);
        openChatHidden.push(openChatChats.pop());
        return {
          ...state,
          chats: openChatChats,
          hidden: openChatHidden,
        };
      }

      if (state.chats.length < state.maxChats) {
        openChatChats.unshift(action.chat);

        return {
          ...state,
          chats: openChatChats,
        };
      } else {
        let { chatsAfter, hiddenAfter } = unshiftChatAndAddExcessOnHidden(
          state.chats,
          state.hidden,
          action.chat
        );

        return {
          ...state,
          chats: chatsAfter,
          hidden: hiddenAfter,
        };
      }

    case CREATE_CHAT:
      let createChatChats = removeReactivity(state.chats);
      let createChatHidden = removeReactivity(state.hidden);

      if (createChatChats.find((elem) => elem.newChat)) {
        const createChatChatIndex = createChatChats.findIndex(
          (elem) => elem.newChat
        );
        createChatChats[createChatChatIndex].collapsed = false;

        return {
          ...state,
          chats: createChatChats,
        };
      }

      let newChatHidden = createChatHidden.find((elem) => elem.newChat);
      if (newChatHidden) {
        newChatHidden.collapsed = false;
        createChatHidden = createChatHidden.filter(
          (elem) => elem.id !== newChatHidden.id
        );

        let { chatsAfter, hiddenAfter } = unshiftChatAndAddExcessOnHidden(
          createChatChats,
          createChatHidden,
          newChatHidden
        );

        return {
          ...state,
          chats: chatsAfter,
          hidden: hiddenAfter,
        };
      }

      let newChat = {
        id: -1 * Math.ceil(Math.random() * 1000),
        name: "Nova Conversa",
        newChat: true,
      };

      if (state.chats.length < state.maxChats) {
        createChatChats.unshift(newChat);

        return {
          ...state,
          chats: createChatChats,
        };
      } else {
        let { chatsAfter, hiddenAfter } = unshiftChatAndAddExcessOnHidden(
          state.chats,
          state.hidden,
          newChat
        );

        return {
          ...state,
          chats: chatsAfter,
          hidden: hiddenAfter,
        };
      }

    case CLOSE_CHAT:
      let closeChats = removeReactivity(state.chats);
      let closeHidden = removeReactivity(state.hidden);
      let isChatOpen = state.chats.find((elem) => elem.id === action.chatId);
      let isChatHidden = state.hidden.find((elem) => elem.id === action.chatId);

      if (isChatOpen) {
        closeChats = closeChats.filter((elem) => elem.id !== action.chatId);
        let shiftedHiddenChat = closeHidden.shift();
        shiftedHiddenChat && closeChats.push(shiftedHiddenChat);
      }

      if (isChatHidden) {
        closeHidden = closeHidden.filter((elem) => elem.id !== action.chatId);
      }

      return {
        ...state,
        chats: closeChats,
        hidden: closeHidden,
      };

    case COLLAPSE_CHAT:
      let collapseChats = removeReactivity(state.chats);
      let chatInstanceIndex = collapseChats.findIndex(
        (elem) => elem.id === action.chatId
      );

      collapseChats[chatInstanceIndex].collapsed =
        !collapseChats[chatInstanceIndex].collapsed;

      return {
        ...state,
        chats: collapseChats,
      };

    case COLLAPSE_ALL_CHATS:
      let collapseAllChats = removeReactivity(state.chats);

      return {
        ...state,
        chats: collapseAllChats.map((chat) => {
          return {
            ...chat,
            collapsed: true,
          };
        }),
      };

    case UPDATE_NEW_CHAT:
      let initialChatIndex = state.chats.findIndex((elem) => elem.newChat);
      let initialChatHiddenIndex = state.hidden.findIndex(
        (elem) => elem.newChat
      );
      let updateNewChatChats = removeReactivity(state.chats);
      let updateNewChatHidden = removeReactivity(state.hidden);

      if (initialChatIndex > -1) {
        updateNewChatChats[initialChatIndex] = action.chat;
      }

      if (initialChatHiddenIndex > -1) {
        updateNewChatHidden[initialChatHiddenIndex] = action.chat;
      }

      return {
        ...state,
        chats: updateNewChatChats,
        hidden: updateNewChatHidden,
      };

    case UPDATE_CHAT:
      let updateChatIndex = state.chats.findIndex(
        (elem) => elem.id === action.chat.id
      );
      let updateChatHiddenIndex = state.hidden.findIndex(
        (elem) => elem.id === action.chat.id
      );
      let updateChatChats = removeReactivity(state.chats);
      let updateChatHidden = removeReactivity(state.hidden);

      if (updateChatIndex > -1) {
        updateChatChats[updateChatIndex] = {
          ...updateChatChats[updateChatIndex],
          ...action.chat,
        };
      }

      if (updateChatHiddenIndex > -1) {
        updateChatHidden[updateChatHiddenIndex] = {
          ...updateChatHidden[updateChatHiddenIndex],
          ...action.chat,
        };
      }

      return {
        ...state,
        chats: updateChatChats,
        hidden: updateChatHidden,
      };

    case CHANGE_CHAT:
      let changeChatChats = removeReactivity(state.chats);
      let foundIndex =
        action.params &&
        action.params.chat &&
        action.params.chat.id &&
        changeChatChats.findIndex((elem) => elem.id === action.params.chat.id);

      if (foundIndex !== -1) {
        changeChatChats[foundIndex] = {
          ...action.params.chat,
          draft: action.params.draft,
        };
      }

      let changeChatHidden = removeReactivity(state.hidden);

      foundIndex =
        action.params &&
        action.params.chat &&
        action.params.chat.id &&
        changeChatHidden.findIndex((elem) => elem.id === action.params.chat.id);

      if (foundIndex !== -1) {
        changeChatHidden[foundIndex] = {
          ...action.params.chat,
          draft: action.params.draft,
        };
      }

      return {
        ...state,
        chats: changeChatChats,
        hidden: changeChatHidden,
      };

    case RECALCULATE_MAX_CHATS:
      const hiddenWrapperWidth = 44;
      const spaceBetweenMessageBoxes = 10;
      const messageBoxWidth = 370;
      const mainContentMarginRight = 17;

      let maxChats =
        parseInt(
          (window.innerWidth - hiddenWrapperWidth - mainContentMarginRight) /
            (messageBoxWidth + spaceBetweenMessageBoxes)
        ) - 1;

      if (maxChats < 1) {
        maxChats = 1;
      }

      let allChats = [].concat(state.chats, state.hidden);

      return {
        ...state,
        chats: allChats.splice(0, maxChats),
        hidden: allChats,
        maxChats,
      };

    default:
      return state;
  }
}

export default chats;
